export function buildNextCommittedFiles(
  currentFiles: File[],
  newFiles: File[],
  maxFiles: number,
): File[] {
  if (newFiles.length === 0) {
    return currentFiles;
  }

  if (maxFiles === 1) {
    return [newFiles[newFiles.length - 1]];
  }

  return [...currentFiles, ...newFiles].slice(0, maxFiles);
}
